import { actionTypes as FirebaseActions } from 'react-redux-firebase';

import { DEFAULT_CREATE_SEND_LINK_SETTINGS_STATE } from '../../../constants/createSendLinkSettings';
import { ICreateSendLinkSettingsState } from '../../../types/createSendLinkSettings';
import { TOneLinkRecipient } from '../../../types/oneLink';
import * as AuthActions from '../../actions/auth';
import * as LinkSettingsActions from '../actions/linkSettings';

export const initialState: ICreateSendLinkSettingsState = DEFAULT_CREATE_SEND_LINK_SETTINGS_STATE;

const recipientKey = (recipient: TOneLinkRecipient) => recipient.id ?? recipient.uid;

const reducer = (state: ICreateSendLinkSettingsState = initialState, action: any): ICreateSendLinkSettingsState => {
  switch (action.type) {
    case AuthActions.ADMIN_ROLE_CHANGED:
    case AuthActions.CHANGE_ORGANIZATION_SUCCESS:
    case FirebaseActions.LOGOUT: {
      return initialState;
    }
    case LinkSettingsActions.PATCH_CS_LINK_SETTINGS: {
      return { ...state, ...action.payload };
    }
    case LinkSettingsActions.CS_UPLOAD_2FA_RECIPIENTS: {
      const { successfulRecipients, failedRecipients } = action.payload;

      return {
        ...state,
        twoFaRecipients: {
          successfulRecipients: state.twoFaRecipients?.successfulRecipients
            ? [...successfulRecipients, ...state.twoFaRecipients.successfulRecipients]
            : successfulRecipients,
          failedRecipients,
        },
      };
    }
    case LinkSettingsActions.CS_DELETE_ALL_ALLOWED_RECIPIENTS: {
      return { ...state, twoFaRecipients: { successfulRecipients: [], failedRecipients: [] } };
    }
    case LinkSettingsActions.CS_DELETE_ALLOWED_RECIPIENT: {
      return {
        ...state,
        twoFaRecipients: {
          successfulRecipients: state.twoFaRecipients?.successfulRecipients?.filter(
            (recipient: TOneLinkRecipient) => recipientKey(recipient) !== action.payload,
          ),
        },
      };
    }
    case LinkSettingsActions.CS_EDIT_ALLOWED_RECIPIENT: {
      const key = recipientKey(action.payload);
      const successfulRecipients = state.twoFaRecipients?.successfulRecipients
        ? [...state.twoFaRecipients.successfulRecipients]
        : [];

      const updatedRecipientIndex = successfulRecipients.findIndex(
        (recipient: TOneLinkRecipient) => recipientKey(recipient) === key,
      );
      if (key && updatedRecipientIndex !== -1) {
        successfulRecipients[updatedRecipientIndex] = action.payload;
      }

      return { ...state, twoFaRecipients: { successfulRecipients } };
    }
    case LinkSettingsActions.CS_ADD_ALLOWED_RECIPIENT: {
      const newRecipient = action.payload;

      return {
        ...state,
        twoFaRecipients: {
          successfulRecipients: state.twoFaRecipients?.successfulRecipients
            ? [newRecipient, ...state.twoFaRecipients.successfulRecipients]
            : [newRecipient],
        },
      };
    }
    default:
      return state;
  }
};

export default reducer;
